import { useSessionStore } from './index';
import type { SessionStore } from '../auth/sessionService';

const ANON_KEY = 'extend_id';

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
};

const useVisitorId = (): string | undefined => {
  const { isAuthenticated, akaname } = useSessionStore((store: unknown) => {
    const sessionStore = store as SessionStore;
    return {
      isAuthenticated: sessionStore.isAuthenticated,
      akaname: sessionStore.user?.akaname as string | undefined,
    };
  });

  // Auth state not resolved yet — wait
  if (isAuthenticated === null) return undefined;

  // Authenticated — wait for user data
  if (isAuthenticated) {
    return akaname ;
  }

  // Not authenticated — anonymous ID
  let anonId = localStorage.getItem(ANON_KEY);
  if (!anonId) {
    anonId = `anon-${generateId()}`;
    localStorage.setItem(ANON_KEY, anonId);
  }
  return `${anonId}`;
};

export default useVisitorId;
